// extracted by mini-css-extract-plugin
module.exports = {"crm":"_44e770c","container":"_29a3183","loader":"_ed0ca44"};